import { Image } from 'expo-image';
import { router } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import { NonProfitOrgProfileResponse } from '@/api/models/nonProfitOrgModels';
import { homeFillIcon } from '@/assets/images/icons';
import EditButton from '@/components/buttons/EditButton';
import InfoButton from '@/components/buttons/InfoButton';
import Text from '@/components/Text';
import { useColor } from '@/hooks/useColor';
import { formatCurrency } from '@/utils/currencyFormat';
import { i18n } from '@/utils/i18n';
import { abbreviateNumber } from '@/utils/number';

const SalariesItem = ({
  canEdit,
  data,
  npoId,
  type
}: {
  canEdit: boolean;
  data: NonProfitOrgProfileResponse['salaries'];
  npoId: NonProfitOrgProfileResponse['id'];
  type: NonProfitOrgProfileResponse['type'];
}) => {
  const colors = useColor();
  return (
    <View>
      <View style={styles.titleContainer}>
        <View style={styles.titleContent}>
          <Text style={[styles.titleText, { color: colors.titleText }]} fontWeight="700">
            {i18n.t('npo_details.insights.salaries')}
          </Text>
          {/* // TODO: update tooltip title  */}
          <InfoButton title={i18n.t('npo_details.insights.salaries')} />
        </View>
        {type === 'CHURCH' && (
          <View style={[styles.allowanceContainer, { marginRight: canEdit ? 10 : 0 }]}>
            <Image source={homeFillIcon} style={styles.allowanceImage} />
            <Text style={{ color: colors.titleText }} fontWeight="700">
              {i18n.t('npo_details.insights.allowance')}
            </Text>
          </View>
        )}
        {canEdit && (
          <EditButton
            onPress={() =>
              router.navigate({
                pathname: '/edit/npoSalaries',
                params: {
                  initialList: JSON.stringify(data),
                  npoId: npoId
                }
              })
            }
          />
        )}
      </View>
      <View style={styles.content}>
        {data && data.length > 0 ? (
          data.map((v, index) => (
            <View key={index}>
              <Text style={{ color: colors.titleText }} fontWeight="700">
                {v.position}
              </Text>
              <View style={styles.row}>
                <Text style={styles.valueText}>{formatCurrency(v.annualSalary)}</Text>
                <Text style={styles.fullName}>{v.fullName}</Text>
                {type === 'CHURCH' && <Text>${abbreviateNumber(v.allowance ?? 0)}/yr</Text>}
              </View>
            </View>
          ))
        ) : (
          <Text> {i18n.t('mix.n_a')}</Text>
        )}
      </View>
      <Divider />
    </View>
  );
};

export default SalariesItem;

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  titleContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center'
  },

  titleText: {
    fontSize: 22,
    marginRight: 10
  },

  content: {
    marginTop: 10,
    marginBottom: 20,
    rowGap: 5
  },

  row: {
    flexDirection: 'row',
    flex: 1,
    marginTop: 3
  },

  valueText: {
    minWidth: 80,
    marginRight: 10,
    marginBottom: 8
  },

  allowanceContainer: {
    flexDirection: 'row',
    columnGap: 10
  },

  allowanceImage: {
    height: 15,
    width: 15
  },

  fullName: {
    flex: 1
  }
});
